// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!./fontiran.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../fonts/ttf/Exodar-Outline.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Exodar-outline';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  /* other formats include: 'woff2', 'truetype, 'opentype',
                            'embedded-opentype', and 'svg' */
}

body {
  font-family: iranyekan !important;
}

#logo {
  font-family: Exodar-outline !important;
}

/* Works on Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: rgb(101, 101, 187) transparent;
}

/* Works on Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

*::-webkit-scrollbar-track {
  background: transparent;
}

*::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 20px;
  border: 2px solid rgb(145, 118, 70);
}

/* Child Voice */
#edited-voice > div > .player {
  height: 42px;
  background: rgba(57, 192, 245, 0.8) !important;
  border-radius: 132px;
  padding: 4px;
  padding-right: 9px;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.player {
  height: 42px;
  background: rgba(245, 158, 57, 0.8);
  border-radius: 132px;
  padding: 4px;
  padding-right: 9px;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.player img.icon {
  width: 34px;
  height: auto;
}

.player img.bar {
  position: absolute;
  bottom: 2px;
  height: 40px;
  width: 88%;
  left: 36px;
}

.progressBarNew {
  margin: 0 10px;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
}

.progressBarNewAll {
  position: absolute;
  border-radius: 4px;
  border: 1px solid #dcdcdc;
  background-color: #dcdcdc;
  width: 100%;
}

.progressBarNewDone {
  border-radius: 4px;
  border: 4px solid #fff;
  background-color: #fff;
  position: absolute;
}

.progressBarNewDone.verify {
  border-radius: 4px;
  border: 1px solid #f59e39;
  background-color: #f59e39;
  position: absolute;
  width: 100%;
}

.progressBarTime {
  width: fit-content;
  font-family: inherit;
  font-size: 12px;
  color: #666666;
  margin: 0 2px;
}

/* pie chart */
.apexcharts-legend-marker {
  margin: 4px;
}`, "",{"version":3,"sources":["webpack://./src/resources/styles/css/style.css"],"names":[],"mappings":"AAEA;EACE,6BAA6B;EAC7B,+DAA+D;EAC/D;4DAC0D;AAC5D;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA,sCAAsC;AACtC;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,8CAA8C;EAC9C,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA,cAAc;AACd;EACE,WAAW;AACb","sourcesContent":["@import url(fontiran.css);\r\n\r\n@font-face {\r\n  font-family: 'Exodar-outline';\r\n  src: url(../../fonts/ttf/Exodar-Outline.ttf) format('truetype');\r\n  /* other formats include: 'woff2', 'truetype, 'opentype',\r\n                            'embedded-opentype', and 'svg' */\r\n}\r\n\r\nbody {\r\n  font-family: iranyekan !important;\r\n}\r\n\r\n#logo {\r\n  font-family: Exodar-outline !important;\r\n}\r\n\r\n/* Works on Firefox */\r\n* {\r\n  scrollbar-width: thin;\r\n  scrollbar-color: rgb(101, 101, 187) transparent;\r\n}\r\n\r\n/* Works on Chrome, Edge, and Safari */\r\n*::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n*::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n*::-webkit-scrollbar-thumb {\r\n  background-color: transparent;\r\n  border-radius: 20px;\r\n  border: 2px solid rgb(145, 118, 70);\r\n}\r\n\r\n/* Child Voice */\r\n#edited-voice > div > .player {\r\n  height: 42px;\r\n  background: rgba(57, 192, 245, 0.8) !important;\r\n  border-radius: 132px;\r\n  padding: 4px;\r\n  padding-right: 9px;\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n}\r\n\r\n.player {\r\n  height: 42px;\r\n  background: rgba(245, 158, 57, 0.8);\r\n  border-radius: 132px;\r\n  padding: 4px;\r\n  padding-right: 9px;\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n}\r\n\r\n.player img.icon {\r\n  width: 34px;\r\n  height: auto;\r\n}\r\n\r\n.player img.bar {\r\n  position: absolute;\r\n  bottom: 2px;\r\n  height: 40px;\r\n  width: 88%;\r\n  left: 36px;\r\n}\r\n\r\n.progressBarNew {\r\n  margin: 0 10px;\r\n  width: 100%;\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.progressBarNewAll {\r\n  position: absolute;\r\n  border-radius: 4px;\r\n  border: 1px solid #dcdcdc;\r\n  background-color: #dcdcdc;\r\n  width: 100%;\r\n}\r\n\r\n.progressBarNewDone {\r\n  border-radius: 4px;\r\n  border: 4px solid #fff;\r\n  background-color: #fff;\r\n  position: absolute;\r\n}\r\n\r\n.progressBarNewDone.verify {\r\n  border-radius: 4px;\r\n  border: 1px solid #f59e39;\r\n  background-color: #f59e39;\r\n  position: absolute;\r\n  width: 100%;\r\n}\r\n\r\n.progressBarTime {\r\n  width: fit-content;\r\n  font-family: inherit;\r\n  font-size: 12px;\r\n  color: #666666;\r\n  margin: 0 2px;\r\n}\r\n\r\n/* pie chart */\r\n.apexcharts-legend-marker {\r\n  margin: 4px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
